var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4707 15.4707C3.34717 15.4707 0 12.1235 0 8C0 3.87646 3.34717 0.529297 7.4707 0.529297C11.5942 0.529297 14.9414 3.87646 14.9414 8C14.9414 12.1235 11.5942 15.4707 7.4707 15.4707ZM7.4707 14.2256C10.9131 14.2256 13.6963 11.4424 13.6963 8C13.6963 4.55762 10.9131 1.77441 7.4707 1.77441C4.02832 1.77441 1.24512 4.55762 1.24512 8C1.24512 11.4424 4.02832 14.2256 7.4707 14.2256ZM3.64014 8.79102C3.34717 8.79102 3.12744 8.57129 3.12744 8.27832C3.12744 7.99268 3.34717 7.77295 3.64014 7.77295H6.95801V3.3418C6.95801 3.05615 7.17773 2.83643 7.46338 2.83643C7.74902 2.83643 7.97607 3.05615 7.97607 3.3418V8.27832C7.97607 8.57129 7.74902 8.79102 7.46338 8.79102H3.64014Z",
    fill: "#CCD1D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time-icon.968b10842eb22ccbb6fa6b0b25d064ab.svg";
export { ForwardRef as ReactComponent };